import { db, auth } from '../firebase';
import { collection, doc, setDoc, onSnapshot } from 'firebase/firestore';

// VIMS 리콜 불러오기 (2026-10-30) — 새 리콜 등록 화면의 "VIMS에서 불러오기".
// CRM 과 VIMS 는 Firebase 프로젝트도 로그인도 따로라 화면이 VIMS 를 직접 읽을 수 없다.
// 관리자가 요청(E2B_VIMS_REQUESTS)을 남기면 서버 함수(functions/index.js crmVimsRecalls)가 VIMS 를
// 읽기 전용으로 조회해 같은 문서에 결과(items)를 적는다. 화면은 그 문서를 지켜본다(AI 분석과 같은 구조).
const REQUEST_COLLECTION = 'E2B_VIMS_REQUESTS';
const WAIT_MS = 60 * 1000;

export const vimsService = {
  /**
   * VIMS 의 리콜 항목을 가져온다(관리자만 — 규칙과 서버가 둘 다 확인한다).
   * @param {string} [requestedByName] 요청자 이름(기록용)
   * @returns {Promise<Array<{projectId: string, carName: string, recallId: string, title: string,
   *   range: string, total: number, startDate: string, endDate: string}>>} 리콜 항목(시작일 최신 먼저)
   */
  fetchRecalls: async (requestedByName = '') => {
    const uid = auth.currentUser && auth.currentUser.uid;
    if (!uid) throw new Error('로그인이 필요합니다.');
    const ref = doc(collection(db, REQUEST_COLLECTION));
    await setDoc(ref, { requestedByUid: uid, requestedByName, status: 'queued', createdAt: new Date().toISOString() });

    return new Promise((resolve, reject) => {
      let finished = false;
      let stop = () => {};
      const finish = (fn, value) => {
        if (finished) return;
        finished = true;
        clearTimeout(timer);
        stop();
        fn(value);
      };
      const timer = setTimeout(() => finish(reject, new Error('1분 동안 응답이 없습니다. 서버 함수가 요청을 처리하지 못했습니다 — 관리자에게 알려 주세요.')), WAIT_MS);
      stop = onSnapshot(ref, (snap) => {
        if (!snap.exists()) return;
        const d = snap.data();
        if (d.status === 'done') finish(resolve, Array.isArray(d.items) ? d.items : []);
        else if (d.status === 'error') finish(reject, new Error(d.error || 'VIMS 리콜을 불러오지 못했습니다.'));
      }, () => finish(reject, new Error('진행 상태를 읽지 못했습니다.')));
      if (finished) stop();
    });
  }
};
